import api from './api';

const StudentService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/students/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/students/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getByCpf: async (cpf) => {
    try {
      const response = await api.get('/students/', { params: { cpf } });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getWithoutEnrollment: async (params = {}) => {
    try {
      const response = await api.get('/students/without-enrollment/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/students/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.patch(`/students/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/students/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default StudentService;
